import React from "react";
import { container_classname } from "../constants";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

const NewPricingHeader: React.FC = () => {
    return (
        <section className={`${container_classname} md:mt-40 mt-20`}>
            <p className="text-xl font-semibold text-center md:mb-5 mb-3" style={{ color: "#3364FA" }}>
                PRICING
            </p>
            <h1 className="font-bold text-center md:mb-6 mb-4 pricing-hero-title">Business-ready plans, built for scale</h1>
            <p className="text-xl font-medium text-center mb-6">Automate your sales funnel and grow your business 2X with WhatsApp automation</p>
            <p className="flex justify-center items-center gap-2">
                <IoIosCheckmarkCircleOutline color="blue" size={23} />
                No credit card required
            </p>
        </section>
    );
};

export default NewPricingHeader;
